import React from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import withStyles from "@material-ui/core/styles/withStyles";
import DeleteIcon from "@material-ui/icons/Delete";
import DateRangeIcon from "@material-ui/icons/DateRange";
import RestoreFromTrashIcon from "@material-ui/icons/RestoreFromTrash";
import Badge from "components/Badge/Badge.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import Button from "components/CustomButtons/Button.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import TablePagination from "components/TablePagination/TablePagination.jsx";
import {
  CONFIGURACION_TIPOGRAFIA_14,
  FILA_BLANCA,
  FILA_GRIS,
  LISTADO_PAGINACION,
} from "config/general/Configuracion";
import {
  grayColor,
  successColor,
  whiteColor,
} from "assets/jss/material-dashboard-pro-react.jsx";
import AplicarSeguridad from "conten/components/AplicarSeguridad";
import EncabezadoGrid from "conten/components/EncabezadoGrid";
import FiltroGeneral from "conten/components/FiltroGeneral";
import TituloPagina2 from "conten/components/TituloPagina2";
import WaitDialog from "conten/components/WaitDialog";
import {
  listarPlan,
  listarPlanZona,
  guardarPlan,
  guardarPlanZona,
} from "./PlanesActions";

import extendedTablesStyle from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.jsx";
import { DirectionsBike, DirectionsCar } from "@material-ui/icons";

// Configuración de columnas de la tabla
const columnasOrdenar2 = [
  { campos: [{ id: "", isSorted: false, label: "Habilitar o inhabilitar" }], xs: 12, sm: 12, md: 1, lg: 1 },
  { campos: [{ id: "p.nombre", isSorted: true, label: "Nombre del plan" }], xs: 12, sm: 12, md: 2, lg: 2 },
  { campos: [{ id: "identificacion", isSorted: true, label: "Plazo (días)" }], xs: 12, sm: 12, md: 1, lg: 1 },
  { campos: [{ id: "identificacion", isSorted: true, label: "Valor" }], xs: 12, sm: 12, md: 1, lg: 1 },
  { campos: [{ id: "identificacion", isSorted: true, label: "Vehículo" }], xs: 12, sm: 12, md: 1, lg: 1 },
  { campos: [{ id: "identificacion", isSorted: true, label: "Minutos de gracia válidos en cada zona" }], xs: 12, sm: 12, md: 1, lg: 1 },
  { campos: [{ id: "identificacion", isSorted: true, label: "Minutos para renovar tiempo de gracia" }], xs: 12, sm: 12, md: 1, lg: 1 },
  { campos: [{ id: "activo", isSorted: true, label: "Estado" }], xs: 12, sm: 12, md: 1, lg: 1 },
  { campos: [{ id: "activo", isSorted: true, label: "Zonas" }], xs: 12, sm: 12, md: 2, lg: 2 },
];

class PlanesMensualesListar extends React.Component {
  state = {
    textAlertInfo: "Un momento mientras completamos su solicitud.",
    paginacion: {
      limite: LISTADO_PAGINACION[0],
      actual: 1,
      filtro: undefined,
      orden: "",
      sentido: "ASC",
    },
  };

  // Ciclo de vida
  componentDidMount() {
    this.traerDatosServidor();
  }

  traerDatosServidor = () => {
    this.props.listarPlan(this.state.paginacion);
    this.props.listarPlanZona(this.state.paginacion);
  };

  cambioPagina = (page) => {
    this.setState(
      (prevState) => ({
        paginacion: { ...prevState.paginacion, actual: page },
      }),
      this.traerDatosServidor
    );
  };

  cambioLimite = (numFilas) => {
    this.setState(
      (prevState) => ({
        paginacion: { ...prevState.paginacion, limite: numFilas },
      }),
      () => this.cambioPagina(1)
    );
  };

  cambioFiltro = (filtro) => {
    this.setState(
      (prevState) => ({
        paginacion: { ...prevState.paginacion, filtro },
      }),
      () => this.cambioPagina(1)
    );
  };
  datosPlanParaServidor = (planConsulta) => {
    var plan = {   
      activo: planConsulta.activo,
      creador: planConsulta.creador,
      es_carro: planConsulta.es_carro,
      fecha_creacion: planConsulta.fecha_creacion,
      id: planConsulta.id,
      informacion: planConsulta.informacion,
      nombre: planConsulta.nombre,
      plan_zona_id: planConsulta.plan_zona_id,
      plazo: planConsulta.plazo,
      valor: planConsulta.valor,
    };
    return plan;
  };

  resultadoActualizar = (_resultado, _mensaje) => {
    this.traerDatosServidor();
  };
  borrarPlan = (plan) => {
    var planActualizar = this.datosPlanParaServidor(plan);
    planActualizar.activo = false;
    this.props.guardarPlan(planActualizar, this.resultadoActualizar);
  };

  activarPlan = (plan) => {
    var planActualizar = this.datosPlanParaServidor(plan);
    planActualizar.activo = true;
    this.props.guardarPlan(planActualizar, this.resultadoActualizar);
  };

  ordenar = (_event, property) => {
    this.setState(
      (prevState) => ({
        paginacion: {
          ...prevState.paginacion,
          orden: property,
          sentido: prevState.paginacion.sentido === "DESC" ? "ASC" : "DESC",
        },
      }),
      () => this.cambioPagina(1)
    );
  };

  render() {
    const { classes, planState, planZonaState } = this.props;
    const { planZona = [] } =
      planZonaState || {};

    const { plan = [], paginacion = {}, isActivityIndicatorShown = false } =
      planState || {};

    if (!paginacion || !plan || !planZona) {
      return <div>Cargando...</div>;
    }
    return (

      <GridItem xs={12}>
        {isActivityIndicatorShown && (
          <WaitDialog text={this.state.textAlertInfo} />
        )}
        <AplicarSeguridad />
        <Card>
          <CardHeader icon>
            <CardIcon
              color='primary'
              style={{ cursor: 'pointer' }}
              onClick={() =>
                this.props.history.push('../admin/administrar-plan')
              }
            >
              <b>{'Nuevo plan'}</b>
              <DateRangeIcon />
            </CardIcon>
            <TituloPagina2
              texto='Listado de planes'
              color='primary'
              classes={classes}
            />
          </CardHeader>

          <CardBody>
            <EncabezadoGrid
              contenidoColumnas={columnasOrdenar2}
              eventoOrdenar={this.ordenar}
              ordenarPor={paginacion.orden}
              sentidoOrden={paginacion.sentido}
              colorFondo={successColor[0]}
              colorTexto={whiteColor}
              tamaLetra='14px'
            />

            <FiltroGeneral
              keyFiltro='Filtroplan'
              colorTexto={whiteColor}
              colorFondo={grayColor[21]}
              eventoFiltrar={this.cambioFiltro}
              tamaLetra='14px'
              texto='Buscar'
              state={this}
            />
            {plan.map((plan, index) => {
              const planZonaRelacionada = planZona.find((zonas) => zonas.id === plan.plan_zona_id);
              const nombresZonas = planZonaRelacionada?.zonas?.map((zona) => zona.nombre).join(", ") || "Sin zonas";
              const icono = (plan.es_carro ? <DirectionsCar /> : <DirectionsBike />);
              return (
                <GridContainer
                  key={`GridContainer-${index}`}
                  container
                  alignItems="center"
                  style={{
                    backgroundColor: index % 2 === 0 ? FILA_BLANCA : FILA_GRIS,
                    ...CONFIGURACION_TIPOGRAFIA_14,
                  }}
                >
                  <GridItem xs={12} sm={12} md={1} lg={1}>
                    <Button
                      color={plan.activo ? "green" : "danger"}
                      simple
                      className={classes.actionButton}
                      onClick={() =>
                        plan.activo
                          ? this.borrarPlan(plan)
                          : this.activarPlan(plan)
                      }
                    >
                      {plan.activo ? <DeleteIcon /> : <RestoreFromTrashIcon />}
                    </Button>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={2} lg={2}>{plan.nombre}</GridItem>
                  <GridItem xs={12} sm={12} md={1} lg={1}>{plan.plazo}</GridItem>
                  <GridItem xs={12} sm={12} md={1} lg={1}>{plan.valor}</GridItem>
                  <GridItem xs={12} sm={12} md={1} lg={1}> {icono}</GridItem>
                  <GridItem xs={12} sm={12} md={1} lg={1}>{planZonaRelacionada?planZonaRelacionada.minutos_plan_zona:'Cargando...'}</GridItem>
                  <GridItem xs={12} sm={12} md={1} lg={1}>{planZonaRelacionada?planZonaRelacionada.minutos_nuevo_plan_zona:'Cargando...'}</GridItem>
                  <GridItem xs={12} sm={12} md={1} lg={1}>
                    <Badge color={plan.activo ? "greenColor" : "danger"}>
                      {plan.activo ? "Activo" : "Inactivo"}
                    </Badge>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={2} lg={2}>{nombresZonas}</GridItem>
                </GridContainer>



              );
            })}

            {paginacion && (
              <TablePagination
                color='success'
                rowsPerPageOptions={LISTADO_PAGINACION}
                pages={Math.ceil(paginacion.total / paginacion.limite)}
                rowsPerPage={paginacion.limite}
                page={paginacion.actual}
                onChangePage={this.cambioPagina}
                onChangeRowsPerPage={this.cambioLimite}
              />
            )}
          </CardBody>
        </Card>
      </GridItem>

    );
  }
}

// Conectar Redux
const mapStateToProps = (state) => ({
  planState: state.planState,
  planZonaState: state.planZonaState,
});

const mapDispatchToProps = (dispatch) => {
  return {
    listarPlan: (paginacion) => dispatch(listarPlan(paginacion, () => { })),
    listarPlanZona: (paginacion) => dispatch(listarPlanZona(paginacion, () => { })),
    guardarPlan: (plan, onSuccess) =>
      dispatch(guardarPlan(plan, onSuccess)),
    guardarPlanZona: (planZona, onSuccess) =>
      dispatch(guardarPlanZona(planZona, onSuccess)),
  }
};



export default withStyles(extendedTablesStyle)(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(PlanesMensualesListar)
);